export const PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE = 'PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE'
export const PERSONS_BENEFICIAL_OWNERS_TABLE_DATA_RECEIVED = 'PERSONS_BENEFICIAL_OWNERS_TABLE_DATA_RECEIVED'
export const PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_TRUE = 'PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_TRUE'
export const PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_FALSE = 'PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_FALSE'

export const PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE_REQUEST = (id) =>
    `PERSONS_BENEFICIAL_OWNERS_${id}_TABLE_CHANGE_REQUEST`
